/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import {
  payPalColor,
  priceCheck,
} from '../../../../../../assets/images/Global';
import styles from '../../MethodsFlow.module.css';
import {
  axiosPostAuthorize,
  axiosPostCapture,
} from '../../../../../../methods/payPal/axiosPost';
import { axiosPutRecalculateCarts } from '../../../../../../methods/products/axiosPut';
import { areThereCartsWithoutEnoughStock } from '../../../../../../utils/stock';
import ThankYouContext from '../../../../../../context/ThankYou/Context';
import organizeDataPayments from '../../../../../../methods/organizeDataPayments';
import ProductContext from '../../../../../../context/Product/Context';
import GlobalContext from '../../../../../../context/Global/Context';
import PaymentContext from '../../../../../../context/Payment/Context';
import AlertModal from '../../../../../AlertModal';
import { fetchSocialByCountry } from '../../../../../../utils/locale';
import data from '../../data';
import totalPriceCarts from '../../../../../../hooks/totalCarts';
import { getIntPrice, getNumberWithDecimals } from '../../../../../../utils/cardForm';

const countries = {
  MXN: 'México',
  COP: 'Colombia',
  CLP: 'Chile',
  PEN: 'Perú',
};

const FlowPayPal = () => {
  const productContext = useContext(ProductContext);
  const paymentContext = useContext(PaymentContext);
  const thankYouContext = useContext(ThankYouContext);
  const globalContext = useContext(GlobalContext);
  const [preventModal, setPreventModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const { setDataPayPal } = thankYouContext;
  const { titlePayPal } = data.paypal;

  const {
    productsWithDiscount,
    carts: cartsProducts,
  } = productContext;
  const {
    isCitaFlow,
    isOnlyComplementaryPayment,
    isOnlyAdvance,
    name,
    email,
    customerId,
    country,
    publicKey,
    origin,
    redirectUrl,
    setEmptyAddressFunction,
    appointmentRedirect,
    buttonUrl: buttonToDashboard,
  } = globalContext;

  const {
    hasAddress,
    totalPrice,
    hasMultiplePayments,
    setTotalPrice,
    setHasMultiplePayments,
  } = paymentContext;

  const { code, number, whatsAppUrl } = fetchSocialByCountry(
    country,
    'whatsapp'
  );

  const dataToPayPal = organizeDataPayments();

  const carts = new URLSearchParams(window.location.search).getAll('cart');

  const outOfStockModal = {
    title: '¡Lo sentimos!',
    description:
      'Uno de los productos de tu carrito ya no está disponible. Regresa a la tienda y vuelve a hacer tu selección.',
    button: 'Regresar a la tienda',
    imgAlert: priceCheck,
    urlRedirect: redirectUrl,
    discardLink: redirectUrl,
  };

  const paymentErrorModal = {
    title: '¡Ocurrió un error!',
    description:
      'Ocurrió un error con el método de pago, por favor intenta con otro método de pago.',
    button: 'Cambiar método de pago',
    imgAlert: priceCheck,
    urlRedirect:document.URL,
  };

  const calculatePrices = () => {
    
    const productsArray = [];
    const [ cart ] = cartsProducts;
    const { lineItems, customLineItems } = cart;
    const cartProducts = [...lineItems, ...customLineItems];
    cartProducts.forEach((product) => {
      let centAmount;
      let images = [];

      if (product.hasOwnProperty("variant")) {
        images = product.variant.images;
      }

      if(product.hasOwnProperty("money")) {
        centAmount = product.money.centAmount;
      }

      if (product.hasOwnProperty("price")) {
        centAmount = product.price.value.centAmount;

        if (product.price.hasOwnProperty("discounted")) {
          centAmount = product.price.discounted.value.centAmount;
        }
      }
      
      if (product.hasOwnProperty("discountedPrice")) {
        centAmount = product.discountedPrice.value.centAmount;
      }

      if (productsWithDiscount.length && product.discountedPricePerQuantity.length) {
        centAmount = product.discountedPricePerQuantity[0].discountedPrice.value.centAmount;
      }

      if (centAmount !== cart.totalPrice.centAmount) {
        centAmount = cart.totalPrice.centAmount;
      }

      const productsConvert = {
        id: product.id,
        productId: product.productId,
        name: 'es-MX',
        price: centAmount,
        quantity: product.quantity,
        totalPrice: centAmount * product.quantity,
        images,
      };

      if (hasMultiplePayments) {
        productsConvert.price = getNumberWithDecimals(totalPrice) * 100;
        productsConvert.totalPrice = getNumberWithDecimals(totalPrice) * 100;
      }

      productsArray.push(productsConvert);
    });

    dataToPayPal.cartData.totalLineItemQuantity = productsArray.length;
    dataToPayPal.cartData.lineItems = productsArray;

    if (hasMultiplePayments) {
      dataToPayPal.cartData.totalPrice = getNumberWithDecimals(totalPrice) * 100;
      dataToPayPal.cartData.lineItems = [productsArray[0]];
    }

  }

  React.useEffect(() => {
    const event = new Event('DOMContentLoaded');
    document.dispatchEvent(event);
  }, []);

  const handleCreateOrder = async () => {

    calculatePrices();
    if (!isCitaFlow && !isOnlyAdvance && !isOnlyComplementaryPayment) {
      if (!hasAddress) {
        setEmptyAddressFunction(true);
      }
    }

    const { data: upToDateCartData } = await axiosPutRecalculateCarts(carts);
    if (areThereCartsWithoutEnoughStock(upToDateCartData.carts)) {
      setPreventModal(true);
    } else {
      setPreventModal(false);
    }

    const lineItems = dataToPayPal.cartData.lineItems.map((item) => {
      const lineItem = {
        name: item.name,
        unitPrice: item.price,
        quantity: item.quantity,
        totalPrice: item.price * item.quantity,
      };

      if (hasMultiplePayments) {
        lineItem.unitPrice = getNumberWithDecimals(totalPrice) * 100;
        lineItem.totalPrice = getNumberWithDecimals(totalPrice) * 100;
        lineItem.quantity = 1;
      }

      return lineItem;
    });

    const body = {
      currency: dataToPayPal.cartData.currency,
      totalPrice: ~~((dataToPayPal.cartData.totalPrice * 100).toFixed(2)),
      lineItems,
    };

    if (hasMultiplePayments) {
      body.totalPrice = getNumberWithDecimals(totalPrice) * 100;
      body.lineItems = [lineItems[0]];
    }

    const response = await axiosPostAuthorize(body);
    return response?.data?.id;
  };

  const handleApproval = async (param) => {
    const lineItems = dataToPayPal.cartData.lineItems.map((item) => {
      const lineItem = {
        name: item.name,
        unitPrice: item.price,
        quantity: item.quantity,
        totalPrice: item.price,
      };

      if (hasMultiplePayments) {
        lineItem.unitPrice = getNumberWithDecimals(totalPrice) * 100;
        lineItem.totalPrice = getNumberWithDecimals(totalPrice) * 100;
      }

      return lineItem;
    });

    const body = {
      country: countries[dataToPayPal.cartData.currency],
      payer: dataToPayPal.payer,
      cartData: {
        id: dataToPayPal.cartData.id,
        currency: dataToPayPal.cartData.currency,
        totalPrice: dataToPayPal.cartData.totalPrice * 100,
        lineItems,
        productCategory: dataToPayPal.cartData.productCategory,
        productKey: dataToPayPal.cartData.productKey,
      },
    };

    if (hasMultiplePayments) {
      body.cartData.totalPrice = getNumberWithDecimals(totalPrice) * 100;
    }

    const response = await axiosPostCapture(param.orderID, body);

    setDataPayPal(response.data);
    let installment;
    if (response.data.credit_financing_offer) {
      installment = {
        term: response.data.credit_financing_offer.term,
        payment:
          response.data.credit_financing_offer.installment_details.payment_due
            .value,
      };
    }
    const tyData = {
      date: response.data?.purchase_units[0]?.payments.captures[0].create_time,
      payment: installment ? installment.term : 0,
      installment,
    };
    localStorage.setItem('tyDataCard', JSON.stringify(tyData));
    if (hasMultiplePayments && cartsProducts[0].cartState === 'Active') {
      const remanent = totalPriceCarts(cartsProducts, false) - getNumberWithDecimals(totalPrice);
      setHasMultiplePayments(true);
      setTotalPrice(`$${remanent}`);
      window.location.reload();
      return response.data;
    }
    if (
      appointmentRedirect &&
      response.data.status !== 'in_process' &&
      origin !== 'appointmentv2'
    ) {
      const urlDashboard = `${buttonToDashboard}&token=${publicKey}54${publicKey}`;
      const urlEncoded = encodeURIComponent(urlDashboard);
      let joiner = redirectUrl && redirectUrl.indexOf('?') >= 0 ? '&':'?&';
      const urlToAppointment = `${redirectUrl}${joiner}transactionId=${response.data.id}&redirectUrl=${urlEncoded}`;
      window.location.href = urlToAppointment;
    } else {
      window.location.replace(`${window.location.origin}/payment/paypal`);
    }

    return response.data;
  };

  const handleError = (error) => {
    console.log('error:', error);
    setErrorModal(true);
  };

  return (
    <>
      {preventModal && (
        <AlertModal
          data={outOfStockModal}
          modal={false}
          discardOption={false}
        />
      )}
      {errorModal && (
        <AlertModal
          data={paymentErrorModal}
          modal={false}
          discardOption={false}
        />
      )}
      <div className={styles.containerPayPal}>
        <img
          className={styles.logoPayPal}
          width={96}
          height={25}
          src={payPalColor}
          alt="PayPal Logo"
        />
        <div className={styles.containerTitlePayPal}>
          <p className={styles.title}>{titlePayPal}</p>
        </div>
        <PayPalScriptProvider
          options={{
            'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
            currency: dataToPayPal.cartData.currency,
          }}
        >
          <PayPalButtons
            style={{ color: 'black', height: 44 }}
            fundingSource="paypal"
            forceReRender={[dataToPayPal, hasAddress]}
            createOrder={handleCreateOrder}
            onApprove={handleApproval}
            onError={handleError}
            className={styles.containerButtonPayPal}
          />
        </PayPalScriptProvider>
      </div>
    </>
  );
};

export default FlowPayPal;
